// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// teamtufino.ecuador@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyCNz1QvEx5CYTLKXP4FYahv-8MroFs8IqE",
    authDomain: "sistematufino.firebaseapp.com",
    projectId: "sistematufino",
    storageBucket: "sistematufino.firebasestorage.app",
    messagingSenderId: "2889243575",
    appId: "1:2889243575:web:8e8bbc74a65153b7f76632",
    measurementId: "G-1GHKSPRSBS"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)